import type {
  OpportunityCreateRequest,
  OpportunityListQuery,
  OpportunityPatchRequest,
  TransitionOpportunityRequest,
} from '@shared/types/opportunity';
import { api } from './client';

/// opportunity API クライアント = fetch のみ。レスポンスは `unknown` を返す。
/// 検証・branded 化は domain の `parseOpportunity` / `parsePaged` 門番が行う (parse, don't validate / #471)。

function buildQueryString(query: OpportunityListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

export function listOpportunities(query: OpportunityListQuery = {}): Promise<unknown> {
  return api.get(`/api/opportunities${buildQueryString(query)}`);
}

export function getOpportunity(id: string): Promise<unknown> {
  return api.get(`/api/opportunities/${encodeURIComponent(id)}`);
}

export function createOpportunity(body: OpportunityCreateRequest): Promise<unknown> {
  return api.post('/api/opportunities', body);
}

export function patchOpportunity(id: string, body: OpportunityPatchRequest): Promise<unknown> {
  return api.patch(`/api/opportunities/${encodeURIComponent(id)}`, body);
}

export function deleteOpportunity(id: string): Promise<void> {
  return api.delete(`/api/opportunities/${encodeURIComponent(id)}`);
}

export function transitionOpportunity(
  id: string,
  body: TransitionOpportunityRequest,
): Promise<unknown> {
  return api.post(`/api/opportunities/${encodeURIComponent(id)}/transition`, body);
}
